export default function TicketDashboardSummary({
  statusSummary,
  onStatusClick,
  selectedStatusId,
  userStatus,
}) {
  const findStatus = (id) => statusSummary.find(s => Number(s.status_id) === Number(id));

  const row1StatusIds = [3, 5, 12];
  const row2StatusIds = [1, 4, 13, 8, 9, 10, 6];

  const row1Stats = row1StatusIds.map(id => findStatus(id)).filter(Boolean);
  const row2Stats = row2StatusIds.map(id => findStatus(id)).filter(Boolean);

  const openOverallCount = row2Stats.reduce((sum, s) => sum + Number(s.count || 0), 0);

  const renderCard = (stat, isTotal = false, isOpenOverall = false) => {
    let label = stat?.label;
    let count = stat?.count || 0;
    let id = stat?.status_id;
    let icon = null;
    let bg = "";
    let text = "";

    if (isTotal) {
      label = "All";
      count = statusSummary.reduce((sum, s) => sum + Number(s.count || 0), 0);
      id = null;
      bg = "bg-all";
      text = "text-black";
      icon = (
        <svg width="44" height="44" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 54V37.8H16.2V54H0ZM18.9 54V37.8H35.1V54H18.9ZM37.8 54V37.8H54V54H37.8ZM0 35.1V18.9H16.2V35.1H0ZM18.9 35.1V18.9H35.1V35.1H18.9ZM37.8 35.1V18.9H54V35.1H37.8ZM0 16.2V0H16.2V16.2H0ZM18.9 16.2V0H35.1V16.2H18.9ZM37.8 16.2V0H54V16.2H37.8ZM5.4 48.6H10.8V43.2H5.4V48.6ZM24.3 48.6H29.7V43.2H24.3V48.6ZM43.2 48.6H48.6V43.2H43.2V48.6ZM5.4 29.7H10.8V24.3H5.4V29.7ZM24.3 29.7H29.7V24.3H24.3V29.7ZM43.2 29.7H48.6V24.3H43.2V29.7ZM24.3 10.8H29.7V5.4H24.3V10.8ZM43.2 10.8H48.6V5.4H43.2V10.8Z" fill="#BDBDBD" />
        </svg>
      );
    } else if (isOpenOverall) {
      label = "Open Tickets (Overall)";
      count = openOverallCount;
      id = "open_overall";
      bg = "bg-orange-100";
      text = "text-orange-900";
      icon = (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17 12c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.24-5 5-5 5 2.24 5 5z" fill="#FFEDD5" />
        </svg>
      );
    } else {
      let lookupLabel = label;
      if (lookupLabel === "Pending Customer Verification & Confirmation") {
        lookupLabel = "Pending (Cust)";
      }
      const colors = getCardColors(lookupLabel?.replace(/\s+/g, "_").toLowerCase());
      bg = colors.bg;
      text = "text-black";
      icon = colors.icon;
      if (label === "Reopen") label = "Reopened";
      if (label === "Pending (Cust)") {
        label = "Pending Customer Verification & Confirmation";
      }
    }

    const isSelected = isOpenOverall ? userStatus === "open" : selectedStatusId === id;

    return (
      <div
        key={id || (isTotal ? "total" : "open_total")}
        onClick={() => {
          if (isOpenOverall) {
            onStatusClick("open_overall_clicked");
          } else {
            onStatusClick(id);
          }
        }}
        className={`
          relative flex-1 min-w-[140px] max-w-full sm:min-w-[150px] min-h-[105px] p-4 cursor-pointer
          duration-300 shadow-md rounded-xl transition-all flex flex-col justify-between ${bg} ${text}
          ${isSelected
            ? "ring-2 ring-red-500 ring-offset-1 shadow-xl scale-[1.03] z-10"
            : "hover:shadow-lg hover:scale-[1.02] hover:-translate-y-1"
          }
        `}
      >
        <div className="text-[10px] sm:text-xs font-bold relative z-[4] whitespace-normal break-words leading-tight mb-2 uppercase tracking-wide opacity-80">
          {label}
        </div>
        <div className="flex items-end justify-between mt-auto">
          <div className="text-3xl sm:text-4xl md:text-5xl font-sans font-black tracking-tighter leading-none">{count}</div>
        </div>
        <div className="absolute right-0 bottom-2 opacity-20 scale-75 transition-transform duration-500 group-hover:scale-90 group-hover:rotate-12">
            {icon}
        </div>
      </div>
    );
  };

  return (
    <div className="w-full space-y-4 px-2 py-4">
      {/* Row 1 - Overview Metrics */}
      {/* Row 1 - Overview Metrics */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {renderCard(null, true)}
        {row1Stats.map(stat => (
          <div key={stat.status_id} className="flex">{renderCard(stat)}</div>
        ))}
      </div>

      {/* Row 2 - Workflow Pipeline */}
      <div className="grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-4">
        {renderCard(null, false, true)}
        {row2Stats.map(stat => (
          <div key={stat?.status_id || Math.random()} className="flex">{renderCard(stat)}</div>
        ))}
      </div>
    </div>
  );
}


function getCardColors(name = "") {
  const key = name.trim().toLowerCase();
  switch (key) {
    case "new":
      return {
        bg: "bg-new",
        text: "text-black",
        icon: (
          <svg
            width="62"
            height="66"
            viewBox="0 0 62 66"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.64258 74.8421C5.78015 74.8421 4.18636 74.037 2.86122 72.4267C1.53608 70.8164 0.872375 68.8783 0.870117 66.6123V9.00356C0.870117 6.74036 1.53382 4.80361 2.86122 3.19331C4.18862 1.58301 5.78241 0.776486 7.64258 0.773743H42.0975C43.0005 0.773743 43.8617 0.979489 44.6811 1.39098C45.5006 1.80247 46.2196 2.38542 46.8382 3.13982L59.8752 18.9822C60.496 19.7366 60.9757 20.6117 61.3143 21.6075C61.6529 22.6033 61.8222 23.6485 61.8222 24.7431V66.6123C61.8222 68.8755 61.1597 70.8136 59.8345 72.4267C58.5094 74.0397 56.9145 74.8449 55.0498 74.8421H7.64258ZM7.64258 66.6123H55.0498V25.4632H44.8911C43.9317 25.4632 43.128 25.0682 42.4801 24.2781C41.8322 23.4881 41.5071 22.5114 41.5049 21.3483V9.00356H7.64258V66.6123ZM44.8911 58.3825C45.8505 58.3825 46.6553 57.9875 47.3055 57.1974C47.9556 56.4073 48.2796 55.4307 48.2773 54.2676C48.2751 53.1044 47.95 52.1278 47.3021 51.3378C46.6542 50.5477 45.8505 50.1527 44.8911 50.1527H17.8013C16.8418 50.1527 16.0382 50.5477 15.3903 51.3378C14.7424 52.1278 14.4173 53.1044 14.415 54.2676C14.4128 55.4307 14.7379 56.4087 15.3903 57.2015C16.0427 57.9943 16.8463 58.388 17.8013 58.3825H44.8911ZM27.9599 25.4632C28.9194 25.4632 29.7242 25.0682 30.3743 24.2781C31.0245 23.4881 31.3484 22.5114 31.3462 21.3483C31.3439 20.1852 31.0188 19.2085 30.3709 18.4185C29.723 17.6284 28.9194 17.2334 27.9599 17.2334H17.8013C16.8418 17.2334 16.0382 17.6284 15.3903 18.4185C14.7424 19.2085 14.4173 20.1852 14.415 21.3483C14.4128 22.5114 14.7379 23.4894 15.3903 24.2822C16.0427 25.075 16.8463 25.4687 17.8013 25.4632H27.9599ZM44.8911 41.9229C45.8505 41.9229 46.6553 41.5278 47.3055 40.7378C47.9556 39.9477 48.2796 38.9711 48.2773 37.8079C48.2751 36.6448 47.95 35.6682 47.3021 34.8781C46.6542 34.0881 45.8505 33.693 44.8911 33.693H17.8013C16.8418 33.693 16.0382 34.0881 15.3903 34.8781C14.7424 35.6682 14.4173 36.6448 14.415 37.8079C14.4128 38.9711 14.7379 39.9491 15.3903 40.7419C16.0427 41.5347 16.8463 41.9283 17.8013 41.9229H44.8911Z"
              fill="#E6F7FB"
            />
          </svg>
        ),
      };
    case "pending_verification_&_closure":
      return {
        bg: "bg-pending",
        text: "text-black",
        icon: (
          <svg
            width="64"
            height="75"
            viewBox="0 0 64 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M49.7778 7.14286H38.4711C36.9778 3 33.0667 0 28.4444 0C23.8222 0 19.9111 3 18.4178 7.14286H7.11111C3.2 7.14286 0 10.3571 0 14.2857V67.8571C0 71.7857 3.2 75 7.11111 75H28.8356C26.7293 72.9514 25.0177 70.5299 23.7867 67.8571H7.11111V14.2857H14.2222V17.8571C14.2222 21.7857 17.4222 25 21.3333 25H35.5556C39.4667 25 42.6667 21.7857 42.6667 17.8571V14.2857H49.7778V32.4286C52.3022 32.7857 54.6844 33.5357 56.8889 34.5714V14.2857C56.8889 10.3571 53.6889 7.14286 49.7778 7.14286ZM28.4444 14.2857C26.4889 14.2857 24.8889 12.6786 24.8889 10.7143C24.8889 8.75 26.4889 7.14286 28.4444 7.14286C30.4 7.14286 32 8.75 32 10.7143C32 12.6786 30.4 14.2857 28.4444 14.2857ZM46.2222 39.2857C36.4089 39.2857 28.4444 47.2857 28.4444 57.1429C28.4444 67 36.4089 75 46.2222 75C56.0356 75 64 67 64 57.1429C64 47.2857 56.0356 39.2857 46.2222 39.2857ZM50.8089 64.2857L44.9422 58.3929C44.6073 58.0632 44.4156 57.6139 44.4089 57.1429V48.25C44.4089 47.25 45.1911 46.4643 46.1867 46.4643C47.1822 46.4643 47.9644 47.25 47.9644 48.25V56.4286L53.2978 61.7857C53.4639 61.9493 53.5961 62.1443 53.6868 62.3595C53.7774 62.5746 53.8247 62.8058 53.8259 63.0394C53.8271 63.2731 53.7821 63.5046 53.6936 63.7207C53.6052 63.9368 53.4749 64.1332 53.3104 64.2984C53.1459 64.4636 52.9505 64.5945 52.7353 64.6833C52.5202 64.7722 52.2896 64.8174 52.057 64.8162C51.8244 64.815 51.5943 64.7675 51.3801 64.6765C51.1658 64.5854 50.9717 64.4526 50.8089 64.2857Z"
              fill="#F7F3FD"
            />
          </svg>
        ),
      };
    case "in_process":
      return {
        bg: "bg-inprocess",
        text: "text-black",
        icon: (
          <svg
            width="83"
            height="78"
            viewBox="0 0 83 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_25_1943)">
              <path
                d="M41.9539 74.7669H33.9422V56.7745H41.9539V74.7669ZM53.9036 44.8248V36.8131H71.896V44.8248H53.9036ZM4 36.8131H21.9924V44.8248H4V36.8131ZM23.8256 32.3319L11.1291 19.6354L16.7645 14L29.461 26.6966L23.8256 32.3319ZM59.1316 67.6379L46.435 54.9413L52.0704 49.3059L64.7669 62.0025L59.1316 67.6379ZM59.1316 14L64.7669 19.6354L52.0704 32.3319L46.435 26.6966L59.1316 14ZM16.7645 67.6379L11.1291 62.0025L23.8256 49.3059L29.461 54.9413L16.7645 67.6379Z"
                fill="#E5F6EA"
              />
            </g>
            <defs>
              <clipPath id="clip0_25_1943">
                <rect
                  width="81.2695"
                  height="77.1546"
                  fill="white"
                  transform="translate(0.893066 0.428864)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      };
    case "reopen":
    case "reopened":
      return {
        bg: "bg-reopen",
        text: "text-black",
        icon: (
          <svg
            width="57"
            height="68"
            viewBox="0 0 57 68"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.5375 75.2555C20.9837 75.6084 21.5034 75.8537 22.0571 75.9729C22.6108 76.092 23.1841 76.0819 23.7333 75.9432L53.5664 68.3855C54.3735 68.1815 55.0902 67.7099 55.6024 67.0457C56.1146 66.3816 56.3929 65.5629 56.3931 64.72V11.8159C56.3929 10.973 56.1146 10.1544 55.6024 9.4902C55.0902 8.82602 54.3735 8.35444 53.5664 8.15046L23.7333 0.592734C23.1839 0.456126 22.611 0.447595 22.0579 0.567784C21.5047 0.687973 20.9857 0.933751 20.5398 1.28662C20.0939 1.63948 19.7329 2.09024 19.4838 2.60496C19.2347 3.11968 19.1041 3.68495 19.1017 4.25823V8.03709H4.18519C3.19616 8.03709 2.24764 8.43522 1.54829 9.14389C0.848946 9.85257 0.456055 10.8137 0.456055 11.8159V64.72C0.456055 65.7222 0.848946 66.6834 1.54829 67.3921C2.24764 68.1007 3.19616 68.4989 4.18519 68.4989H19.1017V72.2777C19.1017 73.4416 19.6313 74.5413 20.5375 75.2555ZM26.56 9.09895L48.9348 14.7672V61.7687L26.56 67.437V9.09895ZM7.91433 60.9411V15.5948H19.1017V60.9411H7.91433Z"
              fill="#FFEBD7"
            />
          </svg>
        ),
      };
    case "pending_testing":
      return {
        bg: "bg-pending_testing",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z" fill="#FCE7F3" />
          </svg>
        ),
      };
    case "testing":
      return {
        bg: "bg-testing",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#E0F7FA" />
          </svg>
        ),
      };
    case "bug_reported":
      return {
        bg: "bg-bug_reported",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.48 5 12 5c-.48 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z" fill="#FEE2E2" />
          </svg>
        ),
      };
    case "testing_approved":
      return {
        bg: "bg-testing_approved",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#DCFCE7" />
          </svg>
        ),
      };
    case "testing_rejected":
      return {
        bg: "bg-testing_rejected",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" fill="#FFEDD5" />
          </svg>
        ),
      };
    case "on_hold":
      return {
        bg: "bg-on_hold",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill="#E0E7FF" />
          </svg>
        ),
      };
    case "pending_customer_verification_&_confirmation":
    case "pending_(cust)":
      return {
        bg: "bg-pending_cust",
        text: "text-black",
        icon: (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" fill="#ede9fe" />
          </svg>
        ),
      };
    case "closed":
      return {
        bg: "bg-closed",
        text: "text-black",
        icon: (
          <svg
            width="82"
            height="79"
            viewBox="0 0 82 79"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_25_1961)">
              <g clip-path="url(#clip1_25_1961)">
                <path
                  d="M66.3961 13.5452C68.3287 13.5452 70.1822 14.3942 71.5487 15.9054C72.9152 17.4166 73.683 19.4663 73.683 21.6035V78.0121C73.683 80.1493 72.9152 82.199 71.5487 83.7102C70.1822 85.2215 68.3287 86.0705 66.3961 86.0705H15.3884C13.4558 86.0705 11.6024 85.2215 10.2358 83.7102C8.86928 82.199 8.10156 80.1493 8.10156 78.0121V21.6035C8.10156 19.4663 8.86928 17.4166 10.2358 15.9054C11.6024 14.3942 13.4558 13.5452 15.3884 13.5452H66.3961ZM66.3961 21.6035H55.4659V78.0121H66.3961V21.6035ZM48.1791 21.6035H15.3884V78.0121H48.1791V21.6035ZM25.5644 38.4133C26.1913 37.719 27.0258 37.3015 27.9113 37.2392C28.7967 37.1769 29.6723 37.474 30.3737 38.0748L30.7162 38.4133L38.4439 46.9552C39.0717 47.6484 39.4492 48.5713 39.5056 49.5505C39.5619 50.5297 39.2933 51.498 38.7499 52.2737L38.4439 52.6565L30.7199 61.2024C30.0657 61.9327 29.1839 62.3589 28.2549 62.3937C27.3259 62.4286 26.42 62.0694 25.7226 61.3899C25.0252 60.7103 24.5891 59.7616 24.5035 58.738C24.4178 57.7144 24.6892 56.6934 25.262 55.8838L25.5644 55.5051L30.7162 49.8078L25.5644 44.1106C24.8814 43.355 24.4977 42.3303 24.4977 41.2619C24.4977 40.1935 24.8814 39.1689 25.5644 38.4133Z"
                  fill="#FAEAEB"
                />
              </g>
            </g>
            <defs>
              <clipPath id="clip0_25_1961">
                <rect
                  width="81.2695"
                  height="78.1833"
                  fill="white"
                  transform="translate(0.257324 0.428864)"
                />
              </clipPath>
              <clipPath id="clip1_25_1961">
                <rect
                  width="87.4419"
                  height="76.1259"
                  fill="white"
                  transform="translate(-2.82861 1.45775)"
                />
              </clipPath>
            </defs>
          </svg>
        ),
      };
    default:
      return { bg: "bg-midGray", text: "text-white" };
  }
}
